export type SocialSharePlatform = 'twitter' | 'linkedin' | 'facebook';

export function buildSocialShareUrl(
  platform: SocialSharePlatform,
  canonicalUrl: string,
  title: string
): string {
  const url = encodeURIComponent(canonicalUrl);
  const text = encodeURIComponent(title);
  switch (platform) {
    case 'twitter':
      return `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    default:
      return canonicalUrl;
  }
}

export function openSharePopup(shareUrl: string): void {
  window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=400');
}

export function canUseNativeShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fallback below */
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export async function shareNative(opts: { title: string; url: string }): Promise<boolean> {
  if (!canUseNativeShare()) return false;
  try {
    await navigator.share({ title: opts.title, url: opts.url, text: opts.title });
    return true;
  } catch {
    return false;
  }
}
